module.exports = __webpack_public_path__ + "static/media/vieriet.12a9d723.png";